module.exports = __webpack_public_path__ + "static/img/ent-72.bdf1fc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-72.jpg
// module id = gMt3
// module chunks = 52